import { helper } from '@ember/component/helper';

/**
 * Only the items that are not archived. A missing `archived` value counts as
 * *not* archived — every scan created before the field has no value — so those
 * items are kept, which is the same rule `in-archive` applies from the other
 * side.
 *
 * The list is optional. `scans/list.hbs` filters `@model`, and a re-render can
 * land while the route is being torn down or redirected away, by which point
 * the model is gone; treating that as an empty list keeps the render pass from
 * throwing.
 */
export default helper(function notInArchive([list]) {
  return (list ?? []).filter(
    (item) => item.archived === undefined || item.archived == false,
  );
});
